const StatusLight = {
  green: {
    tc_name: "服務正常",
    en_name: "Normal Service",
    color: "#4caf50",
  },
  yellow: {
    tc_name: "服務延誤",
    en_name: "Service Delay",
    tc_rmk: "額外候車及行車時間",
    en_rmk: "Additional waiting and travelling time",
    color: "#dbd51f",
  },
  red: {
    tc_name: "服務受阻",
    en_name: "Service Disruption",
    tc_rmk: "請考慮使用其他交通工具",
    en_rmk: "Consider using other transport",
    color: "#f44336",
  },
  typhoon: {
    tc_name: "熱帶氣旋警告信號生效",
    en_name: "Tropical Cyclone Warning Signals issued",
    color: "#1a15bd",
  },
  grey: {
    tc_name: "非服務時間",
    en_name: "Non-service hours",
    color: "#757575",
  },
  pink: {
    tc_name: "服務延誤",
    en_name: "Service Delay",
    tc_rmk: "額外候車及行車時間",
    en_rmk: "Additional waiting and travelling time",
    color: "#dbd51f",
  },
};

const MTRStatus_Dict = { StatusLight };

export default MTRStatus_Dict;
